module.exports = __webpack_public_path__ + "static/img05-f505efb738afaa2bf5c6c25d3bf5c40a.jpg";